export function getDifferenceInPercents(
	value1: number,
	value2: number
): number {
	if (!Number.isFinite(value1) || !Number.isFinite(value2)) {
		return 0
	}

	const difference = value1 - value2
	const percentDifference = (difference / value2) * 100

	return Number.isFinite(percentDifference)
		? Number.parseFloat(percentDifference.toFixed(2))
		: 0
}
